export const messages: Record<string, string> = {
  // Navigation
  'nav.news': 'Actualités',
  'nav.team': 'Équipe',

  // Common
  'common.save': 'Enregistrer',
  'common.saving': 'Enregistrement...',
  'common.cancel': 'Annuler',
  'common.back': 'Retour',
  'common.edit': 'Modifier',
  'common.delete': 'Supprimer',
  'common.loading': 'Chargement...',
  'common.publish': 'Publier',
  'common.publishing': 'Enregistrement…',

  // News
  'news.title': 'Articles',
  'news.new': 'Nouvel article',
  'news.create': 'Rédiger un article',
  'news.edit': "Modifier l'article",
  'news.empty': 'Aucun article pour le moment.',
  'news.loadError': 'Erreur lors du chargement des articles',
  'news.saveSuccess': 'Article enregistré avec succès.',
  'news.saveError': "Erreur lors de l'enregistrement : {message}",
  'news.publishError': 'Erreur lors de la publication : {message}',
  'news.category': 'Catégorie',
  'news.categoryPlaceholder': 'Sélectionner une catégorie',
  'news.titleLabel': 'Titre',
  'news.titlePlaceholder': 'Titre de votre article',
  'news.titleInput': 'Entrer le titre*',
  'news.shortDescription': 'Description courte',
  'news.shortDescriptionLabel': 'Description courte*',
  'news.shortDescriptionPlaceholder':
    'Résumez brièvement le contenu de votre article.',
  'news.category.news': 'Actualités',
  'news.category.events': 'Événements',
  'news.category.updates': 'Mises à jour',

  // Team
  'team.title': "Membres de l'équipe",
  'team.new': 'Nouveau membre',
  'team.create': 'Ajouter un membre',
  'team.edit': 'Modifier le membre',
  'team.empty': 'Aucun membre pour le moment.',
  'team.loadError': 'Erreur lors du chargement des membres',
  'team.saveSuccess': 'Membre enregistré avec succès.',
  'team.updateSuccess': 'Modifications enregistrées.',
  'team.saveError': "Erreur lors de l'enregistrement : {message}",
  'team.name': 'Nom',
  'team.namePlaceholder': 'Entrer le nom',
  'team.group': 'Équipe',
  'team.groupPlaceholder': 'Sélectionner le groupe',
  'team.level': 'Niveau de formation',
  'team.levelPlaceholder': 'Sélectionner le niveau',
  'team.role': 'Rôle',
  'team.rolePlaceholder': 'Sélectionner le poste',
  'team.expirationDate': "Date d'expiration",
  'team.expirationDatePlaceholder': 'Sélectionner la date',
  'team.expirationLabel': "jusqu'au {date}",
};
